var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoveredAlFrescoDining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.82184 11.6338V17.3071M2.82184 21.8824V17.3071M2.82184 17.3071H6.61033C7.7149 17.3071 8.61033 18.2025 8.61033 19.3071V21.8824M5.49768 14.7337H12.0464M18.5952 14.7337H12.0464M12.0464 21.8824V14.7337M12.0464 14.7337V8.47064M12.0464 8.47064H2.11768C3.1974 6.34078 6.74348 2.11744 12.0464 2.11768C17.5197 2.11792 20.6853 6.55166 21.8824 8.47064H12.0464ZM21.0598 21.8824V17.3071M21.0598 11.6338V17.3071M15.3417 21.8824V19.3071C15.3417 18.2025 16.2371 17.3071 17.3417 17.3071H21.0598",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoveredAlFrescoDining);
export default __webpack_public_path__ + "static/media/covered_al_fresco_dining.fada3406e4b6dedb8f7c0d87f13ead6a.svg";
export { ForwardRef as ReactComponent };